export const environment = {
	production: false,
	apiUrl: 'https://dev.tasyire.com/api'
};
